import React from "react";
import RcNotification from 'rc-notification';

const POSITION_CLASSES = {
  "center-top": {
    style: {
      top: "20px",
      left: "50%",
      transform: "translateX(-50%)",
    }
  },
  "top-right": {
    style: {
      top: "20px",
      right: "20px",
    }
  },
  "top-left": {
    style: {
      top: "20px",
      left: "20px",
    }
  },
  "bottom-right": {
    style: {
      bottom: "20px",
      right: "20px",
    }
  },
  "bottom-left": {
    style: {
      bottom: "20px",
      left: "20px",
    }
  },
  "center": {
    style: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    }
  }
};

export const fireNotification = ({ message, type = 0, position = "top-right", duration = 3 }) => {

  const types = {
    0: 'red',
    1: 'blue',
    2: 'green'
  }

  const renderContent = (message) => {
    return (
      <div id="container">
        <div className={`toast panning fadeUp ${types[type]} lighten-1`}>
          <span>{message}</span>
        </div>
      </div>
    )
  }

  return RcNotification.newInstance({
    style: {
      position: "fixed",
      zIndex: 9999,
      ...POSITION_CLASSES[position].style,
    },
  }, (notif) => {
    const option = {
      content: renderContent(message),
      duration,
    };
    notif.notice(option);
  });
}